import React from 'react'
import ScreenVirtualCard from 'src/app/ScreenVirtualCard/ScreenVirtualCard'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { screenVirtualCardRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const ScreenVirtualCardAppRoute: AppRoute = {
  id: AppLocation.ScreenVirtualCard,
  routeProps: screenVirtualCardRouteProps,
  component: <ScreenVirtualCard />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ScreenVirtualCardAppRoute
